import { atom } from 'jotai'
import { feelgreatCountryAtom } from './country.store'

/**
 * Derived feature-flag atom — replaces ad-hoc country-code comparisons in modules.
 *
 * Usage:
 *   const { hasThaPhoneFlow } = useAtomValue(countryFeaturesAtom)
 *
 * Add a new flag here whenever a feature diverges across countries.
 * Never write `country.short === 'THA'` directly in a module — use this atom instead.
 */
export const countryFeaturesAtom = atom(get => {
    const fg = get(feelgreatCountryAtom)
    const short = fg?.short ?? '' // 3-letter ISO code: THA, OMN, KWT

    return {
        /** Thailand uses a separate OTP-based /change-phone-number route */
        hasThaPhoneFlow: short === 'THA',
        /** QR payment page only available in Thailand */
        hasQrPayment: short === 'THA',
        /** Logic A: guest must have a referral to sign up (KWT). Logic B: guest can sign up freely (OMN). */
        guestLogicA: ['KWT'].includes(short)
    }
})
